import { FieldTitle } from '@components/FieldTitle/FieldTitle';
import { MultiSelect } from '@components/MultiSelect/MultiSelect';
import { MultiSelectChips } from '@components/MultiSelect/MultiSelectChips';
import { Controller, useFormContext } from 'react-hook-form';
import { YStack } from 'tamagui';
import { toggleMultiSelectValue } from '@components/MultiSelect/multiSelect.utils';
import type {
  ReportFiltersField,
  ReportFiltersValues,
} from '../../reportFilters.types';

type MultiSelectFilterFieldConfig = Extract<
  ReportFiltersField,
  { type: 'multi-select' }
>;

interface MultiSelectFilterFieldProps {
  field: MultiSelectFilterFieldConfig;
}

export const MultiSelectFilterField = ({
  field,
}: MultiSelectFilterFieldProps): React.ReactElement => {
  const { control } = useFormContext<ReportFiltersValues>();

  return (
    <Controller
      control={control}
      name={field.id}
      render={({ field: controllerField }) => (
        <YStack gap="$2">
          <FieldTitle label={field.label} />
          <MultiSelect
            options={field.options}
            values={controllerField.value ?? []}
            onValuesChange={controllerField.onChange}
            placeholder={field.placeholder}
          />
          <MultiSelectChips
            options={field.options}
            values={controllerField.value ?? []}
            onRemove={(value) => {
              const currentValues = controllerField.value ?? [];
              const newValues = toggleMultiSelectValue(currentValues, value);
              controllerField.onChange(newValues);
            }}
          />
        </YStack>
      )}
    />
  );
};
